module.exports = __webpack_public_path__ + "static/media/logo-header-en-ca.a5194a3c.svg";